function WineTracker() {
  return (
    <div>
      <h1>WineTracker</h1>
      <p>Welcome to Club OS WineTracker</p>
    </div>
  );
}

export default WineTracker;